export default __webpack_public_path__ + "static/media/die6.7625e85a.png";